export default "__VITE_ASSET__5eNK5J$p__"